import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap, retry } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { ILeadHeader } from "../interfaces/leadHeader";
import { Globals } from '../services/globals.service';
import { IFollowUp } from "../interfaces/followup";
import { ISalesNote } from "../interfaces/salesNote";
import { ICSGNote } from "../interfaces/CSGNote";
import { IEmailLead } from "../interfaces/emailLead";
import { ILead } from "../interfaces/lead";
import { IEmailDatabase } from  "../interfaces/emailDatabase";

@Injectable()
export class LeadService {
  url = '';

  constructor(private _http: HttpClient,
    private globals: Globals,
    @Inject('BASE_URL') baseUrl: string) {
    this.url = baseUrl + 'api/standard/';
  }

  private handleError(operation: String) {
    return (err: any) => {
      let errMsg = `error in ${operation}() retrieving ${this.url}`;
      console.log(`${errMsg}:`, err);
      if (err instanceof HttpErrorResponse) {
        // you could extract more info about the error if you want, e.g.:
        console.log(`status: ${err.status}, ${err.statusText}`);
        // errMsg = ...
      }
      return Observable.throw(err);
    }
  }
  // public API

  public getLeadHeaders(): Observable<ILeadHeader[]> {
    return this._http.get<ILeadHeader[]>(this.url + this.globals.cc)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('getLeadHeader'))
      );
  }

  public getLead(id: number): Observable<any[]> {
    return this._http.get<any[]>(this.url + "getbyid/" + id)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
      catchError(this.handleError('getLead'))
      );
  }

  public postLead(lead: ILead): Observable<ILead> {
    return this._http.post<ILead>(this.url, lead)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('postLead'))
      );
  }

  public putLead(lead: ILead): Observable<ILead> {
    return this._http.put<ILead>(this.url, lead)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('putLead'))
      );
  }

      public updateFollowUp(fu: IFollowUp): Observable<IFollowUp> {
    return this._http.put<IFollowUp>(this.url + 'followup', fu)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('updateFollowUp'))
      );
  }

  public updateSalesNote(sn: ISalesNote): Observable<ISalesNote> {
    return this._http.put<ISalesNote>(this.url + 'salesNote', sn)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('updateSalesNote'))
      );
  }

  public updateCSGNote(cn: ICSGNote): Observable<ICSGNote> {
    return this._http.put<ICSGNote>(this.url + 'CSGNote', cn)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('updateCSGNote'))
      );
  }

 public emailSalesLead(id: number): Observable<IEmailLead> {
    return this._http.get<IEmailLead>(this.url + 'sendSalesLead/' + id)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('emailSalesLead'))
      );
  }

  public emailClientDatabase(client: string): Observable<IEmailDatabase> {
    return this._http.get<IEmailDatabase>(this.url + 'emailClientDatabase/' + client)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('emailSalesLead'))
      );
  }

  public deleteLead(id: number): Observable<any> {
    return this._http.delete<any>(this.url + 'deleteLead/' + id)
      .pipe(retry(2),
        tap(data => console.log('server data:', data)),
        catchError(this.handleError('deleteLead'))
      );
  }
}
